import CourseDescription from '@/api/courseDescription';
import { domainUrl } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';

export default function useRedirectToCourseDescription() {
  const router = useRouter();
  const onExploreClick = async (slug: string, params: string, categorySlug?: string) => {
    try {
      const response: { data: string } = await CourseDescription.courseRedirectionURL(
        `${domainUrl}/${categorySlug || 'course'}/${slug}`,
        params
      );
      if (Object.keys(response?.data)?.length > 0) {
        window.open(response?.data, '_self');
      } else {
        router.push(`/${categorySlug || 'course'}/${slug}/${params}`);
      }
    } catch (error) {
      router.push(`/${categorySlug || 'course'}/${slug}/${params}`);
    }
  };
  return {
    onExploreClick,
  };
}
